// import 'ol/ol.css';
// import Map from 'ol/Map';
// import olms from 'ol-mapbox-style';
// import { Vector as VectorSource, Cluster } from 'ol/source';
// import { Vector as VectorLayer } from 'ol/layer';
// import View from 'ol/View';
// import * as olProj from 'ol/proj';
// import Feature from 'ol/Feature';
// import { Point } from 'ol/geom';
// import Style from 'ol/style/Style';
// import { Circle as CircleStyle, Text } from 'ol/style';
// import Fill from 'ol/style/Fill';
// import Stroke from 'ol/style/Stroke';
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static get values() { return { instance: String, nodes: Array, token: String } }

    connect() {
        this.nodesValue = window.mapInstances ? window.mapInstances[this.instanceValue] : [];
    }

    async nodesValueChanged() {
        this.element.innerHTML = '';
        const points = this.nodesValue;

        if (!points || points.length < 1) {
            return null;
        }

        const imports_obj = await Promise.all([
            import(/* webpackChunkName: "vendor-maps" */ 'ol/Map'),
            import(/* webpackChunkName: "vendor-maps" */ 'ol-mapbox-style'),
            import(/* webpackChunkName: "vendor-maps" */ 'ol/source'),
            import(/* webpackChunkName: "vendor-maps" */ 'ol/layer'),
            import(/* webpackChunkName: "vendor-maps" */ 'ol/View'),
            import(/* webpackChunkName: "vendor-maps" */ 'ol/proj'),
            import(/* webpackChunkName: "vendor-maps" */ 'ol/Feature'),
            import(/* webpackChunkName: "vendor-maps" */ 'ol/geom'),
            import(/* webpackChunkName: "vendor-maps" */ 'ol/style'),
            import(/* webpackChunkName: "vendor-maps" */ 'ol/ol.css'),
        ]);

        const [
            { default: Map },
            { default: olms },
            { Vector: VectorSource, Cluster: Cluster },
            { Vector: VectorLayer },
            { default: View },
            olProj,
            { default: Feature },
            { Point },
            { Style, Circle: CircleStyle, Text, Fill, Stroke },
        ] = imports_obj;

        var map = new Map({
            target: this.element.id,
        });

        olms(map, 'https://api.maptiler.com/maps/908dbadb-b4a9-47c6-a3a6-583ade513792/style.json?key=Ouis01B3GajK3e6iqCI4')
            .then((map => {
                map.setView(new View({
                    center: olProj.fromLonLat([0, 22]),
                    zoom: 1,
                }))

                const markerLayer = new VectorLayer({
                    source: new Cluster({
                        distance: 20,
                        minDistance: 20,
                        source: new VectorSource({
                            features: points.map((item) => {
                                const feature = new Feature({
                                    geometry: new Point(olProj.fromLonLat([item.lng, item.lat])),
                                    name: item.name,
                                });

                                return feature;
                            }),
                        }),
                    }),
                    style: (event) => {
                        const features = event.get('features');
                        const length = features.length
                        if (features.length == 1) {
                            const name = features[0].get('name');

                            return new Style({
                                image: new CircleStyle({
                                    radius: 6,
                                    stroke: new Stroke({
                                        color: 'rgba(23,92,255, 0.2)',
                                        width: 12,
                                    }),
                                    fill: new Fill({
                                        color: '#175CFF',
                                    }),
                                }),
                                text: new Text({
                                    text: [name, 'bold 12px "Neurial Grotesk", system, -apple-system, BlinkMacSystemFont, ".SFNSDisplay-Regular", "Helvetica Neue", Helvetica, Arial, sans-serif'],
                                    fill: new Fill({
                                        color: '#0a083b',
                                    }),
                                    offsetY: -30,
                                    stroke: new Stroke({
                                        color: '#fff',
                                        width: 3,
                                    }),
                                }),
                            })
                        } else {
                            return new Style({
                                image: new CircleStyle({
                                    radius: 12,
                                    stroke: new Stroke({
                                        color: 'rgba(23,92,255, 0.2)',
                                        width: 4,
                                    }),
                                    fill: new Fill({
                                        color: '#175CFF',
                                    }),
                                }),
                                text: new Text({
                                    text: length.toString(),
                                    scale: 1.25,
                                    fill: new Fill({
                                        color: '#fff',
                                    }),
                                }),
                            })
                        }
                    },
                });

                map.addLayer(markerLayer);
            }));
        return;
    }
}
